import { render } from "./ExpressTable.vue?vue&type=template&id=bd07dca8&scoped=true"
import script from "./ExpressTable.vue?vue&type=script&lang=js"
export * from "./ExpressTable.vue?vue&type=script&lang=js"

import "./ExpressTable.vue?vue&type=style&index=0&id=bd07dca8&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd07dca8"]])

export default __exports__